import axios from "axios";
import { API } from "../../../backend";
import authHeader from "../../auth-header"
const deleteassets = (state) => {
  return axios.delete(API + "contracts/asset-delete/"+state+"/",{headers: authHeader(),});
};
const DeleteAssetsService = {
    deleteassets,
  };
  export default DeleteAssetsService;